import { ContextProperty, getEagerService } from '../../../service';

const eagerServiceFactory = getEagerService().Factory;

// Historically, if AppName is not set to OWA, PeopleQuery v1 would be triggered, instead of v2 or v3
export function getFindPeopleContext(): ContextProperty[] {
    return [
        eagerServiceFactory.contextProperty({ Key: 'AppName', Value: 'OWA' }),
        eagerServiceFactory.contextProperty({ Key: 'AppScenario', Value: 'peopleHubReact' }),
    ];
}
